export type CommitteeCatalogScope = "national" | "section";

export function committeeListItemSupportingText(
  scope: CommitteeCatalogScope,
  options?: { sectionName?: string }
): string {
  if (scope === "national") return "National Committee";
  if (options?.sectionName?.trim()) return `${options.sectionName.trim()} Committee`;
  return "Section Committee";
}
